// 原生的所有deeplink链接: https://hellotalk.feishu.cn/wiki/wikcnukCnYIbCkkKqGq5R1SuVth
export enum DEEPLINK {
  GO_BACK = `hellotalk://web/goback`, // 返回上一页,安卓用
  CLOSE_WEBVIEW = `hellotalk://close_webview`, // 关闭webview
  SHARE_CARD = `hellotalk://shareCard/chat`, // 语伴卡片分享到聊天
  WECHAT_PAY_V1 = `hellotalk://wechatPayV1`, // 微信支付
  ALI_PAY = `hellotalk://ali_pay`, // 支付宝支付
  BRAINTREE_PAY = `hellotalk://braintree_pay`, // braintree支付-旧
  GOTO_LIVE = `hellotalk://gotoLive`, // 旧的跳转直播间
  OPEN_LIVE_ROOM = `hellotalk://open_live_room`, // 新的跳转直播间
  OPEN_VOICE_ROOM = `hellotalk://open_voice_room`, // 跳转语聊房-旧
  OPEN_VOICE_ROOM_NEW = `hellotalk://open_voiceroom`, // 跳转语聊房-新
  EDIT_LIVE = `hellotalk://edit_live`, // 编辑计划直播-旧
  CHAT_SINGLE = `hellotalk://chat_single`, // 跳转个人聊天，需要userid
  PROFILE = `hellotalk://profile`, // 跳转profile
  CURRENCY_RECHARGE = `hellotalk://currency_Recharge`, // 跳转App充值coins页面
  PURCHASE_NEW = `hellotalk://profile/purchase_new`, // 新会员蓝色特权页面
  IOS_RECOVER_SUBSCRIPTION = `https://apps.apple.com/account/subscriptions`, // iOS恢复订阅页面
  ANDROID_RECOVER_SUBSCRIPTION = `http://play.google.com/store/account/subscriptions`, // Android 谷歌恢复订阅页面
  BUY_VIP = `hellotalk://shop`,
  BUY_VIP_2 = `hellotalk://showVip`,
  MOMENT_PAGE = `hellotalk://action/publishstream`, // 发布动态
  LANG_EXCHANGE_PLAN = `hellotalk://chat/lang_exchange/plan`, // 语言交换计划  ?id=xxxx&source=xxxx
  LANG_EXCHANGE_DETAIL = `hellotalk://chat/lang_exchange/detail`, // 语言交换详情 ?id=xxxx&source=xxxx
  FAVORITE_LABEL_EDITOR = `hellotalk://profile/favorite_label_edit`, // 标签编辑 ?id=xxx&source=xxx
  FRIENDS = `hellotalk://friends`, // 选择好友
  FAVORITE_WORD_PAGE = `hellotalk://profile/favorite_plugin?favorite_tab=9`, // 跳转收藏-识单词界面的deeplink
  MEDAL_WALL = `hellotalk://profile/start_medal_wall` // 跳转勋章墙
}
